import React from "react";
import ReactTelInput from "react-telephone-input";
import PropTypes from "prop-types";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

import GridItem from "components/Grid/GridItem.js";

import config from "config/config.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";
import { dangerColor } from "assets/jss/material-dashboard-pro-react.js";
import "react-telephone-input/lib/withStyles";

const useStyles = makeStyles(shippingAddressStyle);

function TelephoneInput({ ...props }) {
  const classes = useStyles();

  const helpTextClasses = classNames({
    [classes.labelRootError]:
      props.error && props.error.telephone && props.error.telephone.error,
    [classes.helpTextClasses]:
      props.error && props.error.telephone && props.error.telephone.error
  });

  const inputLabelClasses = classNames({
    [classes.labelRootError]:
      props.error && props.error.telephone && props.error.telephone.error,
    [classes.labelRoot]: true
  });
  return (
    <GridItem xs={12} sm={6} md={6} lg={6}>
      <InputLabel
        className={inputLabelClasses}
        style={
          props.error && props.error.telephone && props.error.telephone.error
            ? { color: `${dangerColor[0]} !important` }
            : {}
        }
        htmlFor={"TELEPHONE"}
        {...props.labelProps}
      >
        {props.labelText}
      </InputLabel>
      <ReactTelInput
        defaultCountry="it"
        initialValue={props.prefix}
        onChange={e => {
          props.onChangePrefix(e);
        }}
        className={classes.input}
        autoFormat
        inputProps={{
          autoFocus: false,
          value: props.prefix + " " + props.telephone || "",
          style: {
            borderRadius: 0,
            border: 0,
            borderBottom: "1px solid #cbcbcb",
            float: "left",
            width: "100%",
            boxShadow: "none",
            fontSize: "15px",
            fontFamily: "Archivo Narrow"
          },
          onChange: e => {
            const telephoneChange = e.target.value.replace(props.prefix, "");
            props.onChange(telephoneChange.trim());
          }
        }}
        style={{ float: "left", width: "100%" }}
        onBlur={() => {}}
        flagsImagePath={`${config.cdn}ico/flags.png`}
        autoComplete="off"
      />
      {props.error && props.error.telephone && props.error.telephone.error ? (
        <FormHelperText className={helpTextClasses}>
          {props.error.telephone.helperText}
        </FormHelperText>
      ) : null}
    </GridItem>
  );
}

TelephoneInput.propTypes = {
  labelText: PropTypes.any,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onChangePrefix: PropTypes.func,
  error: PropTypes.object,
  prefix: PropTypes.string,
  telephone: PropTypes.string
};

TelephoneInput.defaultProps = {
  labelText: "",
  labelProps: {},
  id: "telephone",
  onChange: () => {},
  onChangePrefix: () => {},
  error: {},
  prefix: "+39",
  telephone: ""
};

export default TelephoneInput;
